<template>
  <div class="page-shell">
    <PageBanner
      eyebrow="CONTACT DETAIL"
      background-image="/page/contact-banner.jpg"
      :title="title"
      :subtitle="{ 'zh-CN': '宏邦变压器 · 匠心智造标杆', 'en-US': 'Hongbang Transformer: A Benchmark of Ingenious Manufacturing' }"
    />
    <PageIntro
      :side-title="{ 'zh-CN': '联系我们', 'en-US': 'Contact' }"
      :items="contactItems"
      :breadcrumb="breadcrumb"
      :title="title"
      :paragraphs="paragraphs"
      :stretch="true"
    />
  </div>
</template>

<script>
import PageBanner from "../../components/common/PageBanner.vue";
import PageIntro from "../../components/common/PageIntro.vue";
import { navGroups } from "../../data/site";

export default {
  name: "ContactSubPage",
  components: { PageBanner, PageIntro },
  props: {
    title: [String, Object]
  },
  computed: {
    contactItems() {
      return navGroups.find((item) => item.path === "/contact").children;
    },
    paragraphs() {
      return [
        {
          "zh-CN": "该页面已是独立菜单文件，可继续补充招聘岗位、营销网络、在线留言或地图信息。",
          "en-US": "This page is already an independent menu file and can later include job openings, marketing networks, online messages or maps."
        },
        {
          "zh-CN": "当前先按站点结构与菜单跳转关系完成拆分，便于后续精细化调整。",
          "en-US": "It is currently split according to site structure and routing logic, making later fine-tuning easier."
        }
      ];
    },
    breadcrumb() {
      return {
        "zh-CN": "首页 > 联系我们 > " + this.$pick(this.title),
        "en-US": "Home > Contact > " + this.$pick(this.title)
      };
    }
  }
};
</script>
